import { defaultDataByType } from 'shared/constants/slate';


export const makeNodeProps = ({ type, isVoid = false }, data = {}) => {
  const defaultData = defaultDataByType[type] || {};
  data = { ...defaultData, ...data };

  return { type, isVoid, data };
};



// WEBPACK FOOTER //
// ./src/components/slate/utils/makeNodeProps.js